import termsService, { type Terms } from '../services/terms.service';
import { useLegalDocument } from './useLegalDocument';

export interface TermsState {
  /** The terms in force, once they have been read. */
  terms: Terms | null;
  /** True when they could not be read: a page that cannot show the text cannot take the acceptance. */
  unavailable: boolean;
  /** Reads them again (the version in force moved while the page was open). */
  reload: () => void;
}

/** The Terms and Conditions in force. A page that creates an account shows them and echoes their version. */
export function useTerms(): TermsState {
  const { document, unavailable, reload } = useLegalDocument(() => termsService.current());
  return { terms: document, unavailable, reload };
}
